'use client';
import React, { useEffect } from 'react';
import loadBackgroudImages from '../../common/loadBackgroudImages';

function Header({ item }) {
  useEffect(() => {
    loadBackgroudImages();
  }, [item]);

  if (!item) return null;

  return (
    <header className="header blog-header section-padding pb-0">
      <div className="container mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="caption">
              <div className="sub-title fz-12">
                <a href="/portfolio">
                  <span>{item.category}</span>
                </a>
              </div>
              <h1 className="fz-55 mt-30">
                {item.title}{' '}
                {item.titleHighlight && (
                  <span className="fw-200">{item.titleHighlight}</span>
                )}
              </h1>
            </div>
            <div className="info d-flex mt-40 align-items-center">
              <div className="left-info">
                <div className="d-flex align-items-center">
                  <div className="author-info">
                    <div className="d-flex align-items-center">
                      <span className="opacity-7">Proje Tipi</span>
                      <h6 className="fz-16 ml-20">{item.category || 'Web Sitesi'}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-info ml-auto">
                {item.url && (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="butn butn-sm butn-bg main-colorbg radius-5"
                  >
                    <span className="text">Siteyi Ziyaret Et</span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="background bg-img mt-80"
        data-background={item.coverImg || '/assets/imgs/works/1/1.jpg'}
      ></div>
    </header>
  );
}

export default Header;
